import { User } from '@/entity/authentication/user';
import { Permission } from '@/entity/authentication/permission';

export class LocalStorage {

    private LOCAL_STORAGE_USER_KEY = "user.id"
    private LOCAL_STORAGE_USER_MOBILE_KEY = "user.mobile"
    private LOCAL_STORAGE_USER_TOKEN_KEY = "user.token"
    private LOCAL_STORAGE_USER_PROFILE_KEY = "user.profile"
    private LOCAL_STORAGE_USER_PERMISSION_KEY = "user.permissions"
    private LOCAL_STORAGE_APP_MENU_KEY = "app.menu"

    set user(anUser) {
        if (anUser) {
            localStorage.setItem(this.LOCAL_STORAGE_USER_KEY, anUser.id.toString())
        }
    }
    get user() {
        const userId = localStorage.getItem(this.LOCAL_STORAGE_USER_KEY)
        if (userId) {
            return new User(parseInt(userId))
        }
        return undefined
    }

    set userProfile(profile) {
        if (profile) {
            localStorage.setItem(this.LOCAL_STORAGE_USER_PROFILE_KEY, JSON.stringify(profile))
        }
    }
    get userProfile() {
        const profile = localStorage.getItem(this.LOCAL_STORAGE_USER_PROFILE_KEY)
        if (profile) {
            return JSON.parse(profile ? profile : "");
        }
        return undefined
    }

    set menus(menus) {
        if (menus) {
            localStorage.setItem(this.LOCAL_STORAGE_APP_MENU_KEY, JSON.stringify(menus))
        }
    }
    get menus() {
        const menus = localStorage.getItem(this.LOCAL_STORAGE_APP_MENU_KEY)
        if (menus) {
            return JSON.parse(menus ? menus : "");
        }
        return undefined
    }

    set userPermissions(permissions) {
        if (permissions) {
            localStorage.setItem(this.LOCAL_STORAGE_USER_PERMISSION_KEY, JSON.stringify(permissions))
        }
    }
    get userPermissions() {
        const permissions = localStorage.getItem(this.LOCAL_STORAGE_USER_PERMISSION_KEY);
        return JSON.parse(permissions ? permissions : "");
    }

    get mobile() {
        const mobile = localStorage.getItem(this.LOCAL_STORAGE_USER_MOBILE_KEY)
        if (mobile) {
            return mobile
        }
        return undefined
    }

    set mobile(mobile) {
        if (mobile) {
            localStorage.setItem(this.LOCAL_STORAGE_USER_MOBILE_KEY, mobile)
        }
    }

    set otp(anOtp) {
        if (anOtp) {
            localStorage.setItem("user.otp", anOtp)
        }
    }
    get otp() {
        const otp = localStorage.getItem("user.otp")
        if (otp) {
            return otp
        }
        return undefined
    }

    get authToken() {
        return localStorage.getItem(this.LOCAL_STORAGE_USER_TOKEN_KEY)
    }

    clear() {
        window.localStorage.clear()
    }
}